import type { ComponentType, PropsWithChildren } from 'react';
import React from 'react';
import { withTheme } from '@emotion/react';

import { Viewport } from '../enums/Viewport';
import type { WithTheme } from '../providers/ThemeProvider';
import OnWindowResize from './OnWindowResize';

interface MatchedViewportProps extends PropsWithChildren {
  viewport: Viewport;
}

interface MatchedViewportState {
  isMatched: boolean;
}

class MatchedViewport extends React.Component<
  WithTheme<MatchedViewportProps>,
  MatchedViewportState
> {
  static defaultProps = {
    viewport: Viewport.All,
  };

  constructor(props: WithTheme<MatchedViewportProps>) {
    super(props);

    this.onResize = this.onResize.bind(this);

    this.state = {
      isMatched: false,
    };
  }

  getCurrentViewport() {
    const { breakpoints } = this.props.theme;
    const tablet = parseInt(breakpoints[0], 10);
    const desktop = parseInt(breakpoints[1], 10);
    const windowInnerWidth = window.innerWidth;

    if (windowInnerWidth < tablet) {
      return Viewport.Mobile;
    }

    if (windowInnerWidth >= tablet && windowInnerWidth < desktop) {
      return Viewport.Tablet;
    }

    if (windowInnerWidth >= desktop) {
      return Viewport.Desktop;
    }

    return Viewport.All;
  }

  isMatched() {
    const { viewport } = this.props;
    if (viewport === Viewport.All) {
      return true;
    }

    const currentViewport = this.getCurrentViewport();

    return viewport.includes(currentViewport);
  }

  onResize() {
    this.setState({
      isMatched: this.isMatched(),
    });
  }

  render() {
    return (
      <OnWindowResize onResize={this.onResize}>
        {this.state.isMatched ? this.props.children : null}
      </OnWindowResize>
    );
  }
}

// fixme - emotion typings
export default withTheme<ComponentType<MatchedViewportProps>>(MatchedViewport);
